import { APPLICATION_DISCONNECTED } from '..//application/application.constants';
import { StoreItem } from '../Store';
import { Category } from '../../models';
import ReducerCreator from '../registerReducer';
import { buildLoadingStoreItem, buildStoreItem } from '../storeItemBuilder';
import {
    CATEGORIES_ADD_SUCCESS,
    CATEGORIES_DELETE_SUCCESS,
    CATEGORIES_LOAD,
    CATEGORIES_LOAD_SUCCESS,
    CATEGORIES_UPDATE_SUCCESS
} from './categories.constants';

const r = new ReducerCreator<Category>()
    .register<Category[]>(CATEGORIES_LOAD, (state, payload) => buildLoadingStoreItem())
    .register<Category[]>(CATEGORIES_LOAD_SUCCESS, (state, payload) => buildStoreItem(payload))
    .register<Category[]>(CATEGORIES_ADD_SUCCESS, (state, payload) => buildStoreItem(payload))
    .register<Category[]>(CATEGORIES_DELETE_SUCCESS, (state, payload) => buildStoreItem(payload))
    .register<Category[]>(CATEGORIES_UPDATE_SUCCESS, (state, payload) => buildStoreItem(payload))
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        const newState = new StoreItem<Category>();
        return newState;
    });

export function categoriesReducer(
    state: StoreItem<Category> = new StoreItem<Category>(),
    action: { type: string, payload: any }
) {
    return r.reduce(state, action);
}